import { graphql, useLazyLoadQuery } from "react-relay"
import type {
  ShiftPlanFilterInput,
  useShiftPlanOverviewQuery as UseShiftPlanOverviewQueryType,
} from "@/modules/shift-plan-overview/services/__generated__/useShiftPlanOverviewQuery.graphql"
import type { ShiftPlanRoleFilter } from "@/types/__generated__/union-types"

const shiftPlanOverviewQuery = graphql`
  query useShiftPlanOverviewQuery($date: Date!, $roleFilter: ShiftPlanRoleFilter!, $filters: ShiftPlanFilterInput) {
    shiftPlanOverview(date: $date, roleFilter: $roleFilter, filters: $filters) {
      userName
      isNurse
      isOperationsLead
      specialties
      languages
      teams
      licenses
      qualifications
      shifts {
        shiftStart
        shiftEnd
        shiftType
        shiftInformation
      }
    }
  }
`

export const useShiftPlanOverviewQuery = (
  date: string,
  roleFilter: ShiftPlanRoleFilter,
  filters?: ShiftPlanFilterInput | null,
) => {
  return useLazyLoadQuery<UseShiftPlanOverviewQueryType>(
    shiftPlanOverviewQuery,
    {
      date,
      roleFilter,
      filters,
    },
    {
      fetchPolicy: "network-only",
    },
  )
}
